<template>
  <div class="br-subleft overflow-y-auto" style="z-index: 1" :data-min="status">
    <div>
      <h6
        v-show="!isHistoryData"
        class="
          tx-uppercase tx-12 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("rm.原料单状态") }}
      </h6>
      <nav
        class="mg-b-30 nav br-nav-mailbox flex-column"
        v-show="!isHistoryData"
      >
        <template v-for="item in rm_status">
          <div
            class="group-name-wrap mg-b-5"
            :key="item.id"
            :class="{
              active: item.id == status_id,
            }"
          >
            <a
              href="javascript:;"
              class="nav-link"
              @click="filterOrderByStatus(item.id, item.name)"
            >
              {{ item.name }}
              <span
                v-if="item.id == 9"
                v-show="rm_status_num[item.id] > 0"
                class="
                  pd-r-8 pd-l-8
                  tx-8 tx-white
                  rounded-5
                  mg-l-10
                  bg-gray-300
                "
                >{{ rm_status_num[item.id] }}</span
              >
              <span
                class="pd-r-8 pd-l-8 tx-8 tx-white rounded-5 mg-l-10 bg-teal"
                v-else-if="!(item.id == 7)"
                v-show="rm_status_num[item.id] > 0"
                >{{ rm_status_num[item.id] }}</span
              >
            </a>
          </div>
        </template>
      </nav>
    </div>
    <div>
      <h6
        class="
          tx-uppercase tx-12 tx-mont tx-spacing-1
          pd-x-10
          tx-white-7
          pd-b-10
        "
      >
        {{ $t("mall.条件筛选") }}
      </h6>
      <div class="pd-x-10">
        <div class="form-group mg-b-30">
          <select
            class="form-control form-control-dark select2 mg-b-10 select-mg"
            :data-placeholder="$t('distributor.采购单号')"
            v-model="codeType"
          >
            <option :value="1">
              {{ $t("distributor.采购单号") }}
            </option>
            <option :value="2">
              {{ $t("other.物流单号") }}
            </option>
            <option :value="3">
              {{ $t("order.SKU编号") }}
            </option>
            <option :value="4">
              {{ $t("product.SPU编号") }}
            </option>
          </select>
          <div class="search-sku">
            <input
              v-model="code"
              type="text"
              :placeholder="placeholder"
              class="form-control form-control-dark tx-13 mg-b-5"
            />
            <label
              class="ckbox mg-b-0 d-inline-block"
              data-toggle="tooltip"
              data-placement="right"
              data-trigger="hover"
              :data-original-title="
                $t('rm.勾选模糊匹配表示搜索采购单的SKU编号中包含当前填写的内容')
              "
              v-if="codeType == 3"
            >
              <input type="checkbox" v-model="isVague" />
              <span class="tx-white-8 tx-13">{{
                $t("order.SKU模糊搜索")
              }}</span>
            </label>
          </div>
        </div>
        <select-supplier
          class="mg-b-30"
          :noLike="true"
          :key_word="name"
          :key_id="id"
          @changeKeyword="changeName"
          @keywordEnter="filtrateName"
          @keywordFilter="filtrateNameDefault"
        ></select-supplier>
        <div class="form-group mg-b-30">
          <select
            class="form-control form-control-dark select2 mg-b-10 select-mg"
            :data-placeholder="$t('distributor.采购日期')"
            v-model="timeType"
          >
            <option :value="1">
              {{ $t("distributor.采购日期") }}
            </option>
            <option :value="2">
              {{ $t("order.发货日期") }}
            </option>
            <option :value="3">
              {{ $t("distributor.入库日期") }}
            </option>
          </select>
          <div class="datepicker-group">
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="timeCreatedFrom"
                data-id="datepicker-from"
                type="text"
                class="form-control-dark form-control fc-datepicker"
                :placeholder="$t('mall.起始日期')"
              />
            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="timeCreatedTo"
                data-id="datepicker-to"
                type="text"
                class="form-control form-control-dark fc-datepicker"
                :placeholder="$t('mall.截止日期')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group mg-b-30">
      <button
        type="button"
        class="
          btn btn-primary search btn-block
          tx-uppercase tx-11 tx-spacing-2 tx-medium
        "
        @click="filterOrder"
      >
        {{ $t("mall.筛 选") }}
      </button>
      <!-- todo3-原料订单 -->
      <button
        @click="batchSearch('rmOrder')"
        class="
          btn btn-primary batchSearch btn-block
          tx-uppercase tx-11 tx-spacing-2 tx-medium
        "
      >
        {{ $t("distributor.批量搜索") }}
      </button>
    </div>
  </div>
</template>

<script>
import SelectSupplier from "./select-supplier";

export default {
  components: { SelectSupplier },
  props: [
    "status",
    "isHistoryData",
    "rm_status_num",
    "rm_status",
    "status_id",
    "key_codeType",
    "key_code",
    "key_isVague",
    "key_name",
    "key_id",
    "key_timeType",
    "key_timeCreatedFrom",
    "key_timeCreatedTo",
  ],
  data() {
    return {
      statusId: "",
      codeType: 1,
      code: "",
      isVague: "",
      name: "",
      name1: "",
      id: "",
      id1: "",
      timeType: 1,
      timeCreatedFrom: "",
      timeCreatedTo: "",
    };
  },
  computed: {
    placeholder() {
      if (this.codeType == 2) {
        return this.$t("other.物流单号");
      } else if (this.codeType == 3) {
        return this.$t("order.SKU编号");
      } else if (this.codeType == 4) {
        return this.$t("product.SPU编号");
      } else {
        return this.$t("distributor.采购单号");
      }
    },
  },
  watch: {
    status_id() {
      this.statusId = this.status_id;
    },
    key_codeType() {
      this.codeType = this.key_codeType;
    },
    key_code() {
      this.code = this.key_code;
    },
    key_isVague() {
      this.isVague = this.key_isVague;
    },
    key_name() {
      this.name = this.key_name;
    },
    key_id() {
      this.id = this.key_id;
    },
    key_timeType() {
      this.timeType = this.key_timeType;
    },
    key_timeCreatedFrom() {
      this.timeCreatedFrom = this.key_timeCreatedFrom;
    },
    key_timeCreatedTo() {
      this.timeCreatedTo = this.key_timeCreatedTo;
    },
  },
  mounted() {
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  methods: {
    batchSearch(key){
      this.$emit('batchSearch', key)
    },
    // 格式化时间选择框
    datepickerSelect() {
      let vm = this;
      $("[data-id=datepicker-from]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.timeCreatedFrom = selectedDate;
          },
        });
      });
      $("[data-id=datepicker-to]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.timeCreatedTo = selectedDate;
          },
        });
      });
    },
    changeName(name, id) {
      if (!id) return;
      this.name = name;
      this.id = id;
      this.$parent.filterProp.name = this.keyName;
      this.$parent.filterProp.id = this.keyNameId;
    },
    filtrateName(name, id) {
      if (!id || id == "e999") {
        ShowTip(this.$t("distributor.没有匹配的供应商"), "danger");
        this.name = "";
        this.id = "";
      } else {
        //清空按供应商名
        this.name = name;
        this.id = id;
      }
      this.filterOrder();
    },
    filtrateNameDefault(name, id) {
      this.name1 = name;
      this.id1 = id;
    },
    // 点击状态
    filterOrderByStatus(id, name) {
      if (this.$parent.filterProp.status == id) {
        this.$parent.filterProp.status = this.$parent.activeGroupName = "";
      } else {
        this.$parent.filterProp.status = id;
        this.$parent.activeGroupName = name;
      }

      this.filterOrder();
    },
    // 筛选
    filterOrder() {
      this.$parent.filterProp.page = 1;
      this.$parent.filterProp.codeType = this.codeType;
      this.$parent.filterProp.code = this.code;
      this.$parent.filterProp.isVague = this.isVague;
      this.$parent.filterProp.timeType = this.timeType;
      this.$parent.filterProp.timeCreatedFrom = this.timeCreatedFrom;
      this.$parent.filterProp.timeCreatedTo = this.timeCreatedTo;
      if (!this.id) {
        this.name = "";
        this.id = this.id1;
        this.name = this.name1;
        this.$parent.filterProp.name = this.name1;
        this.$parent.filterProp.id = this.id1;
      } else {
        if (!this.id1) {
          this.$parent.filterProp.name = this.name;
          this.$parent.filterProp.id = this.id;
        } else {
          this.name = "";
          this.id = this.id1;
          this.name = this.name1;
          this.$parent.filterProp.name = this.name1;
          this.$parent.filterProp.id = this.id1;
        }
      }
      this.$parent.getRMOrder(undefined, 'common');
    },
  },
};
</script>